module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.controller.hasError, 'has-warning': _vm.controller.hasWarning, 'has-success': _vm.controller.hasSuccess
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.controller.name))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controller.value),
      expression: "controller.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.controller.placeholder
    },
    domProps: {
      "value": (_vm.controller.value)
    },
    on: {
      "blur": function($event) {
        _vm.controller.value = _vm.controller.value
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.controller, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.controller.hasWarning || _vm.controller.hasError) ? _c('span', {
    staticClass: "help-block"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-exclamation-circle': _vm.controller.hasError, 'fa-exclamation-triangle': _vm.controller.hasWarning
    }
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.controller.message))])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-321bb6fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-321bb6fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/corecontrols/forminput/forminput.scp.html
// module id = 530
// module chunks = 0